"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AMPLITUDE_EXPERIMENT_CLIENT_CONFIG = exports.USER_ONGOING_AB_TESTS = exports.DONOR_ONGOING_AB_TEST = exports.ORGANIZATION_ONGOING_AB_TESTS_KEY = exports.AMPLITUDE_GROUP_TYPE = exports.AMPLITUDE_EVENT_KEY = void 0;
exports.AMPLITUDE_EVENT_KEY = "AmplitudeEventKey";
exports.AMPLITUDE_GROUP_TYPE = "Organization";
exports.ORGANIZATION_ONGOING_AB_TESTS_KEY = "organization_ongoing_ab_tests";
exports.DONOR_ONGOING_AB_TEST = "donor_ongoing_ab_test";
exports.USER_ONGOING_AB_TESTS = "user_ongoing_ab_tests";
const AMPLITUDE_EXPERIMENT_CLIENT_CONFIG = ({ fetchTimeoutMillis }) => ({
    fetchTimeoutMillis,
    fetchRetries: 2,
    fetchRetryBackoffMinMillis: 400,
    fetchRetryTimeoutMillis: fetchTimeoutMillis * 2,
});
exports.AMPLITUDE_EXPERIMENT_CLIENT_CONFIG = AMPLITUDE_EXPERIMENT_CLIENT_CONFIG;
